'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".Banner-module_banner__1vplH{border:1px solid;border-radius:4px;box-sizing:border-box;padding:1rem}";
var styles = {"banner":"Banner-module_banner__1vplH"};
styleInject["default"](css_248z, 'fcbeca9c-d167-479a-a8b3-3fce0c213d25');

exports["default"] = styles;
